// extracted by mini-css-extract-plugin
export default {"layoutToggleFormControl":"layout-toggle-module__layoutToggleFormControl--BCgAt","layoutToggleLabel":"layout-toggle-module__layoutToggleLabel--Q4kO_"};